<template>
	<div class="u-title">
		<div class="title-text"><slot>{{ title }}</slot></div>
		<div class="accessary"><slot name="accessary"></slot></div>
	</div>
</template>
<script>
	export default {
		name: 'uTitle',
		props: {
			title: {
				type: String,
				default: 'title'
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/uTitle/uTitle.vue